//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import Cuid from '@models/Cuid';
import { useSetExpiryDateMutation } from '@uia/details/hooks/useSetExpiryDateMutation';
import { UIA_RIGHTS_FLOW_TRACKING_IDS } from '@uia/rights/constants/uiaRightsConstants';
import { UIARightsSetExpiry } from '@uia/rights/rights-expiry/UIARightsSetExpiry';

interface UIARightsSetExpiryFormProps {
  cuid: Cuid;
  expiryTime?: Date;
  handleOnPreviousButtonClick: () => void;
  onUpdateRightsSuccess?: () => void;
}

export const UIARightsSetExpiryScreen = ({
  cuid,
  expiryTime,
  handleOnPreviousButtonClick,
  onUpdateRightsSuccess,
}: UIARightsSetExpiryFormProps) => {
  const { isPending: isLoadingSetExpiryDate, mutate: setExpiryDate } =
    useSetExpiryDateMutation();

  const handleOnSubmit = (expiryDate?: Date) => {
    setExpiryDate(
      {
        cuid: cuid,
        expirationTime: expiryDate,
      },
      { onSuccess: onUpdateRightsSuccess },
    );
  };

  return (
    <UIARightsSetExpiry
      alertText='Content with an expiry date is not eligible for distribution to the Visual Syndication Network'
      expiryTime={expiryTime}
      handleOnPreviousClick={handleOnPreviousButtonClick}
      handleSubmit={handleOnSubmit}
      isExpiryDateOptional={false}
      isSubmitInProgress={isLoadingSetExpiryDate}
      previousButtonTrackingId={
        UIA_RIGHTS_FLOW_TRACKING_IDS.SET_EXPIRY_PREVIOUS_BUTTON
      }
      submitButtonText='Submit'
      submitButtonTrackingId={
        UIA_RIGHTS_FLOW_TRACKING_IDS.SET_EXPIRY_SUBMIT_BUTTON
      }
      title='Set Expiry Date'
    />
  );
};
